import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Menu, MenuItem, Grid, Typography, useTheme } from "@mui/material";
import { ChevronLeft } from "@mui/icons-material";
import { styled } from "../../../theme";
import { servicesList } from '../../../helpers/services.data';
import { ReactComponent as AppLogo } from '../../../assets/icons/icon_ds_id.svg';
import MenuGroupIcon from '../../../assets/icons/icon_menu_group';
import D24MenuIcon from '../../../assets/icons/icon_ds24_menu_item';


function Header() {
  const theme = useTheme();
  const location = useLocation();

  const ref = new URLSearchParams(location.search).get("ref") || "d24";

  const { profile } = useSelector(state => state.profile)
  const [anchorEl, setAnchorEl] = useState(null);

  const currentServiceIdx = servicesList.findIndex(serviceRoute => serviceRoute.name === ref)
  const [currentServiceId, setCurrentServiceId] = useState(currentServiceIdx);

  const open = Boolean(anchorEl);

  const handleMenuChange = async (index, name) => {
    setCurrentServiceId(index) 
    setAnchorEl(null)
    const url = new URL(window.location.href);

    name === 'd24' ? url.search = '' : url.searchParams.set('ref', name) 
    window.history.pushState({}, '', url.toString());
  }

  const returnToServer = () => {
    const redirects = { acc:  `https://oico.app/acc`, debt: `https://ya.ds24.ru/debt` };

    // Иначе это д24 по умолчанию
    const DS24_server = profile.server == 'DS24_DEV' ? 'https://s0.ds24.ru/' : 'https://ds24.ru/';
    const redirectUrl = redirects[ref] || `${DS24_server}ui/request`;


    window.location.href = redirectUrl;
  }

  return (
    <Grid container px={2} pt={2.5} pb={0.5}
      sx={{ flexDirection: { xs: 'row-reverse', md: 'row' }, justifyContent: { xs: 'space-between', md: 'flex-start' } }}
    >
      <Grid xs={3} item sx={{ display: 'flex', alignItems: 'center', gap: 2, justifyContent: 'center', pr: { xs: 1.5, md: 0 } }}>
        {/* <Box sx={{ '& svg': { width: { xs: 21, md: 21 }, height: 'auto', cursor: 'pointer' } }}>
          <MenuGroupIcon onClick={(e) => setAnchorEl(e.currentTarget)} />
        </Box>   */}
        <Box sx={{ '& svg': { width: { xs: 75, md: 75 }, height: 'auto', cursor: 'default' } }}><AppLogo /></Box>  
        <Menu
          open={open}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          disableAutoFocusItem
          sx={{...styled('menu', 'sx'),  '& .MuiList-root': { gap: 1 }}}
          slotProps={styled('menu', 'slotProps')}
        >
          {servicesList.map(({ title, note, name }, index) => (
            <MenuItem 
              key={index} 
              selected={currentServiceId === index}
              onClick={() => handleMenuChange(index, name)}
            >
              <Grid sx={{ display: 'flex', gap: 1.5, alignItems: 'center', py: 0.5 }}>
                <D24MenuIcon />
                <Grid sx={{ minWidth: 0, flex: 1 }}>
                  <Typography sx={{ fontWeight: 700, fontSize: 14 }}>{title}</Typography>
                  <Typography sx={{ color: theme.palette.grey.main, fontSize: 14 }}>{note}</Typography>
                </Grid>
              </Grid>
            </MenuItem>
          ))}
        </Menu>
      </Grid>

      <Grid 
        xs={9} 

        
        sx={{ 
          display: 'flex', 
          alignItems: 'center',
          transition: 'all 0.3s ease', 
          '&:hover': {
          '& .chevron-icon, & .hover-text': {
            fill: theme.palette.OICO.neutral[500], 
            color: theme.palette.OICO.neutral[500]
          }}
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={() => returnToServer()}>
          <ChevronLeft className="chevron-icon" sx={{ fill: theme.palette.OICO.neutral[600], transition: 'fill 0.3s ease' }} />
          <Typography  className="hover-text" sx={{ color: theme.palette.OICO.neutral[600], fontSize: 14, cursor: 'pointer', transition: 'color 0.3s ease' }}>
            Вернуться к сервису
          </Typography>
        </Box>
      </Grid>

    </Grid>
  )
}

export default Header